import { Box, Divider, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { Colors } from '../../../../../../../design/color/Colors';
import { IQuestion } from '../../../../../../../../service/unit/interface/IUnitQuiz';
import { IQuizQuestionsResult } from '../../../../../../../../service/unitResult/IUnitResultModel';
import { QuizAccordionItem } from '../components/QuizAccordionItem';

interface IPassingQuizAccordionProps {
  question: IQuestion;
  answer?: IQuizQuestionsResult;
  index: number;
  isEbaleToCheck: boolean;
  isEbaleToRePass: boolean;
  navigationRedirect: (title: string) => void;
}

const defaultAnswer = {
  answers: [],
  result: 0,
};
export const PassingQuizAccordionContent = observer(
  ({ question, answer, isEbaleToCheck, isEbaleToRePass, index, navigationRedirect }: IPassingQuizAccordionProps) => {

    const effectiveAnswer = answer || defaultAnswer;
    return (
      <Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            padding: '8px 16px',
            cursor: 'pointer',
          }}
          onClick={() => navigationRedirect(question.pseudoId)}
        >
          <QuizAccordionItem
            result={effectiveAnswer?.result}
            index={index}
            showResult={!isEbaleToCheck || !isEbaleToRePass}
          />
          <Typography
            variant="caption"
            sx={{
              color: Colors.textSecondary,
              width: '100%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {question.name}
          </Typography>
        </Box>
        <Divider />
      </Box>
    );
  },
);
